// import React from 'react';
// import config from '../../config/api';
// import GoogleLogin from 'react-google-login';
// import google_logo from '../../img/google_logo.png';
// import send_icon from '../../img/send.png';

// const LoginComponent = ({ handleRequest, handleSuccess, handleFailure, handleLoginClick }) => {
//   return(
//     <div className="g-sign-in-wrapper">
//       <div className="left-half">
//         <div className="intro-text">
//           <h3>Intelligence</h3>
//           <h3>Centers</h3>
//           <p><span>C</span>ontent</p>
//           <p><span>M</span>anagement</p>
//           <p><span>S</span>ystem</p>
//         </div>
//       </div>
//       <div className="right-half">
//         <GoogleLogin
//           clientId={config.client_id}
//           className="hidden-login-btn"
//           buttonText="Login"
//           onRequest={handleRequest}
//           onSuccess={handleSuccess}
//           onFailure={handleFailure}
//         />
//         <div id="customBtn" className="customGPlusSignIn" onClick={handleLoginClick}>
//           <span className="icon">
//             <p className="optional-text">Sign In</p>
//             <img src={google_logo} alt="Google-Logo" />
//           </span>
//           <span className="buttonText">Login with Google</span>
//           <span className="send-icon">
//             <img src={send_icon} alt="Send-Icon" />
//           </span>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default LoginComponent;
import React from "react";
import config from "../../config/api";
// import { GoogleLogin } from 'react-google-login';
import settings_icon from "../../img/settings_icon.svg";
import { Button } from "antd";

const AuthComponent = ({ handleSuccess, handleFailure, is_auth_attempt }) => {
  return (
    <div className="login-container">
      <div className="welcome-heading">
        <h1>INTELLIGENCE CENTER CMS</h1>
      </div>
      <div className="login-wrapper">
        <div className="login-button-wrapper">
          <img className="login-img" src={settings_icon} alt="" />
          {/* <GoogleLogin
            clientId={config.google_client_id}
            render={renderProps => (
              is_auth_attempt ? <div class="loader-16"></div> : <button className="login-button" onClick={renderProps.onClick} disabled={renderProps.disabled}>LOGIN</button>
            )}
            onSuccess={handleSuccess}
            onFailure={handleFailure}
          /> */}
          <Button
            className="ms-sign-in"
            id="SignIn"
            type="primary"
            onClick={() => handleSuccess()}
          >
            Login
          </Button>
        </div>
        <div className="teams">
          <h2 className="team-headings sales">SALES</h2>
          <h2 className="team-headings research">RESEARCH</h2>
          <h2 className="team-headings editing">EDITING</h2>
          <h2 className="team-headings formatting">FORMATTING</h2>
          <div className="lines first"></div>
          <div className="lines second"></div>
          <div className="lines third"></div>
          <div className="lines fourth"></div>
          <div className="lines fifth"></div>
          <div className="lines sixth"></div>
          <div className="dot"></div>
        </div>
      </div>
    </div>
  );
};

export default AuthComponent;



// WEBPACK FOOTER //
// ./src/components/Login/LoginComponent.js